import { PageHeading } from './components/PageHeading/PageHeading';
import { RecentlyViewedStorefronts } from './components/RecentlyViewedStorefronts/RecentlyViewedStorefronts';
import { SearchResultsPageBreadcrumbs } from './components/SearchBreadcrumb/SearchBreadcrumb';
import { SearchControls } from './components/SearchControls/SearchControls';
import { SRPSearchBarProvider } from './components/SearchControls/SRPSearchBarContext';
import { TopPicksSection } from './components/TopPicks/TopPicksSection';
import { VendorSearchResultsGrid } from './components/VendorSearchResultsGrid/VendorSearchResultsGrid';
import { StickyScrollProvider } from './contexts/StickyScrollContext';
import { VendorGridCardsProvider } from './contexts/VendorGridCardsProvider';

type SearchResultsContentProps = {
  fromSrp: boolean;
  isPricingRatingTest1: boolean;
  isPricingRatingTest2: boolean;
};

export const SearchResultsContent = ({
  fromSrp,
  isPricingRatingTest1,
  isPricingRatingTest2,
}: SearchResultsContentProps) => {
  return (
    <SRPSearchBarProvider>
      <TopPicksSection
        fromSrp={fromSrp}
        isPricingRatingTest1={isPricingRatingTest1}
        isPricingRatingTest2={isPricingRatingTest2}
      />
      <SearchResultsPageBreadcrumbs location="top" />
      <StickyScrollProvider>
        <PageHeading />
        <SearchControls />
        <RecentlyViewedStorefronts
          isPricingRatingTest1={isPricingRatingTest1}
          isPricingRatingTest2={isPricingRatingTest2}
        />
        <VendorGridCardsProvider>
          <VendorSearchResultsGrid
            fromSrp={fromSrp}
            isPricingRatingTest1={isPricingRatingTest1}
            isPricingRatingTest2={isPricingRatingTest2}
          />
        </VendorGridCardsProvider>
      </StickyScrollProvider>
    </SRPSearchBarProvider>
  );
};
